<template>
    <b-modal 
        ref="certificateModal"
        size="xl"
        :title="$t('task_certificate_modal_title')"
        @hidden="resetValues"
        hide-footer
    >
        <b-form @submit="submit">
            <b-row>
                <b-col class="mb-3">
                    <b-card>
                        <b-form-group
                            :label="$t('task_certificate_prev_transport')"
                            label-for="form_certificate_prev_transport"
                            :label-cols="3"
                        >
                            <b-form-input 
                                id="form_certificate_prev_transport"
                                v-model="formPrevTransport"
                            />
                        </b-form-group>
                        <b-form-group
                            :label="$t('task_certificate_next_transport')"
                            label-for="form_certificate_next_transport"
                            :label-cols="3"
                        >
                            <b-form-input 
                                id="form_certificate_next_transport"
                                v-model="formNextTransport"
                            />
                        </b-form-group>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col :md=6 class="mb-3">
                    <b-card>
                        <b-form-group
                            :label="$t('task_certificate_clening_procedure')"
                            label-size="lg"
                            label-class="font-weight-bold pt-0"
                        >
                            <div
                                v-for="(option, index) in procedureOptions"
                                :key="index"
                            >
                                <b-form-group
                                    :label="option.label"
                                    :label-for="option.id"
                                    :label-cols="9"
                                >
                                    <b-form-checkbox :id="option.id" v-model="option.value" size="lg" />
                                </b-form-group>
                                <b-collapse :visible="option.value">
                                    <b-form-group 
                                        v-if="option.subInput"
                                        :label="option.subInput.type === 'input' && option.subInput.label ? option.subInput.label : null"
                                        label-size="sm"
                                        label-align="right"
                                        :label-cols="6"
                                    >
                                        <b-form-input 
                                            v-if="option.subInput.type === 'input'"
                                            v-model="option.subInput.value"
                                            size="sm"
                                            :required="option.value ? option.subInput.required : false"
                                        />
                                        <b-form-radio-group
                                            v-if="option.subInput.type === 'radio'"
                                            v-model="option.subInput.value"
                                            :options="option.subInput.options"
                                            size="sm"
                                            :required="option.value ? option.subInput.required : false"
                                        />
                                    </b-form-group>
                                </b-collapse>
                            </div>
                        </b-form-group>
                    </b-card>
                </b-col>
                <b-col :md=6 class="mb-3">
                    <b-card>
                        <b-form-group
                            :label="$t('task_certificate_objects_cleaned')"
                            label-size="lg"
                            label-class="font-weight-bold pt-0"
                        >
                            <div
                                v-for="(option, index) in objectOptions"
                                :key="index"
                            >
                                <b-form-group
                                    :label="option.label"
                                    :label-for="option.id"
                                    :label-cols="9"
                                >
                                    <b-form-checkbox :id="option.id" v-model="option.value" size="lg" />
                                </b-form-group>
                                <b-collapse :visible="option.value">
                                    <b-form-group 
                                        v-if="option.subInput"
                                        :label="option.subInput.type === 'input' && option.subInput.label ? option.subInput.label : null"
                                        label-size="sm"
                                        label-align="right"
                                        :label-cols="6"
                                    >
                                        <b-form-input 
                                            v-if="option.subInput.type === 'input'"
                                            v-model="option.subInput.value"
                                            size="sm"
                                            :required="option.value ? option.subInput.required : false"
                                        />
                                        <b-form-radio-group
                                            v-if="option.subInput.type === 'radio'"
                                            v-model="option.subInput.value"
                                            :options="option.subInput.options"
                                            size="sm"
                                            :required="option.value ? option.subInput.required : false"
                                        />
                                    </b-form-group>
                                </b-collapse>
                            </div>
                        </b-form-group>
                    </b-card>
                </b-col>
            </b-row>
            <b-row class="mb-3">
                <b-col>
                    <b-card>
                        <b-form-group
                            :label="$t('task_certificate_drying')"
                            label-size="lg"
                            label-class="font-weight-bold pt-0"
                        >
                            <b-form-row>
                                <b-col v-for="(option, index) in dryingOptions" :key="index" :md=4>
                                    <b-form-group
                                        :label="option.label"
                                        :label-for="option.id"
                                        :label-cols="9"
                                    >
                                        <b-form-checkbox :id="option.id" v-model="option.value" size="lg" />
                                    </b-form-group>
                                </b-col>
                            </b-form-row>
                        </b-form-group>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-card>
                        <b-form-group
                            :label="$t('task_certificate_examination')"
                            label-size="lg"
                            label-class="font-weight-bold pt-0"
                        >
                            <b-form-row>
                                <b-col
                                    v-for="(option, index) in examinationOptions"
                                    :key="index"
                                    :md=3
                                >
                                    <b-form-group
                                        :label="option.label"
                                        :label-for="option.id"
                                        :label-cols="9"
                                    >
                                        <b-form-checkbox :id="option.id" v-model="option.value" size="lg" />
                                    </b-form-group>
                                    <b-collapse :visible="option.value">
                                        <b-form-group 
                                            v-if="option.subInput"
                                            :label="option.subInput.label ? option.subInput.label : null"
                                            label-size="sm"
                                            label-align="right"
                                            :label-cols="6"
                                        >
                                            <b-form-input 
                                                v-if="option.subInput.type === 'input'"
                                                v-model="option.subInput.value"
                                                size="sm"
                                                :required="option.value ? option.subInput.required : false"
                                            />
                                            <b-form-input 
                                                v-if="option.subInput.type === 'number'"
                                                type="number"
                                                :step=0.1
                                                v-model="option.subInput.value"
                                                size="sm"
                                                :required="option.value ? option.subInput.required : false"
                                            />
                                            <b-form-radio-group
                                                v-if="option.subInput.type === 'radio'"
                                                v-model="option.subInput.value"
                                                :options="option.subInput.options"
                                                size="sm"
                                                :required="option.value ? option.subInput.required : false"
                                            />
                                        </b-form-group>
                                    </b-collapse>
                                </b-col>
                            </b-form-row>
                        </b-form-group>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
					<hr />
					<b-form-group class="text-right mb-0">
						<b-button type="submit" variant="primary">{{ $t('task_certificate_modal_button_load') }}</b-button>
					</b-form-group>
                </b-col>
            </b-row>
        </b-form>
    </b-modal>
</template>

<script>

export default {
    name: 'TaskCertificateModal',
    props: [
        'task',
        'loadCertificatePDF',
    ],
    data() {
        return {
            formPrevTransport: null,
            formNextTransport: null,
            procedureOptions: [
                /*
                {
                    label: this.$t('task_certificate_form_flushing'),
                    id: 'form_certificate_flushing',
                    value: false
                },
                */
                {
                    label: this.$t('task_certificate_form_cleaning'),
                    id: 'form_certificate_cleaning',
                    value: false,
                    subInput: {
                        type: 'radio',
                        options: [
                            { text: this.$t('task_certificate_form_hot'), value: "hot" },
                            { text: this.$t('task_certificate_form_cold'), value: "cold" },
                        ],
                        value: null,
                        required: true,
                    },
                },
                {
                    label: this.$t('task_certificate_form_solving'),
                    id: 'form_certificate_solving',
                    value: false,
                    subInput: {
                        type: 'input',
                        value: null,
                        label: this.$t('task_certificate_form_chemical'),
                        required: true,
                    },
                },
                /*
                {
                    label: this.$t('task_certificate_form_steaming'),
                    id: 'form_certificate_steaming',
                    value: false
                },
                */
                {
                    label: this.$t('task_certificate_form_mechanical'),
                    id: 'form_certificate_mechanical',
                    value: false,
                    subInput: {
                        type: 'input',
                        value: null,
                        label: this.$t('task_certificate_form_info'),
                        required: false,
                    },
                },
                {
                    label: this.$t('task_certificate_form_other'),
                    id: 'form_certificate_other',
                    value: false,
                    subInput: {
                        type: 'input',
                        value: null,
                        label: this.$t('task_certificate_form_info'),
                        required: false,
                    },
                },
            ],
            objectOptions: [
                {
                    label: this.$t('task_certificate_form_vehicle_tanks'),
                    id: 'form_certificate_vehicle_tanks',
                    value: false,
                    subInput: {
                        type: 'radio',
                        options: [
                            { text: 1, value: 1 },
                            { text: 2, value: 2 },
                            { text: 3, value: 3 },
                            { text: 4, value: 4 },
                        ],
                        value: null,
                        required: true,
                    },
                },
                {
                    label: this.$t('task_certificate_form_trailer_tanks'),
                    id: 'form_certificate_trailer_tanks',
                    value: false,
                    subInput: {
                        type: 'radio',
                        options: [
                            { text: 1, value: 1 },
                            { text: 2, value: 2 },
                            { text: 3, value: 3 },
                            { text: 4, value: 4 },
                        ],
                        value: null,
                        required: true,
                    },
                },
                {
                    label: this.$t('task_certificate_form_gaskets'),
                    id: 'form_certificate_gaskets',
                    value: false,
                },
                {
                    label: this.$t('task_certificate_form_pump'),
                    id: 'form_certificate_pump',
                    value: false,
                },
                {
                    label: this.$t('task_certificate_form_blow_off_pipes'),
                    id: 'form_certificate_blow_off_pipes',
                    value: false,
                },
                {
                    label: this.$t('task_certificate_form_pneumatic_pipes'),
                    id: 'form_certificate_pneumatic_pipes',
                    value: false,
                },
                {
                    label: this.$t('task_certificate_form_blow_off_hoses'),
                    id: 'form_certificate_blow_off_hoses',
                    value: false,
                },
            ],
            dryingOptions: [
                {
                    label: this.$t('task_certificate_form_hot_air_drying'),
                    id: 'form_certificate_hot_air_drying',
                    value: false,
                },
                {
                    label: this.$t('task_certificate_form_mechanical_drying'),
                    id: 'form_certificate_mechanical_drying',
                    value: false,
                },
                {
                    label: this.$t('task_certificate_form_evaportation_drying'),
                    id: 'form_certificate_evaportation_drying',
                    value: false,
                },
            ],
            examinationOptions: [
                {
                    label: this.$t('task_certificate_form_exam_clean'),
                    id: 'form_certificate_exam_clean',
                    value: false,
                },
                {
                    label: this.$t('task_certificate_form_exam_dry'),
                    id: 'form_certificate_exam_dry',
                    value: false,
                },
                {
                    label: this.$t('task_certificate_form_exam_odeur'),
                    id: 'form_certificate_exam_odeur',
                    value: false,
                },
                {
                    label: this.$t('task_certificate_form_exam_ph_measured'),
                    id: 'form_certificate_exam_ph_measured',
                    value: false,
                    subInput: {
                        type: 'number',
                        value: null,
                        label: this.$t('task_certificate_form_result'),
                        required: true,
                    },
                },
            ],
        }
    },
    methods: {
        submit() {
			event.preventDefault();
            this.loadCertificatePDF(JSON.stringify({
                task_id: this.task.id,

                transport_prev: this.formPrevTransport,
                transport_next: this.formNextTransport,

                //procedure_flushing: this.procedureOptions[0].value,
                procedure_cleaning: this.procedureOptions[0].value,
                procedure_cleaning_temp: this.procedureOptions[0].subInput.value,
                procedure_solving: this.procedureOptions[1].value,
                procedure_solving_chemical: this.procedureOptions[1].subInput.value,
                //procedure_steaming: this.procedureOptions[3].value,
                procedure_mechanical: this.procedureOptions[2].value,
                procedure_mechanical_info: this.procedureOptions[2].subInput.value,
                procedure_other: this.procedureOptions[3].value,
                procedure_other_info: this.procedureOptions[3].subInput.value,

                obj_vehicle_tanks: this.objectOptions[0].value,
                obj_vehicle_tanks_count: this.objectOptions[0].subInput.value,
                obj_trailer_tanks: this.objectOptions[1].value,
                obj_trailer_tanks_count: this.objectOptions[1].subInput.value,
                obj_gaskets: this.objectOptions[2].value,
                obj_pump: this.objectOptions[3].value,
                obj_blow_off_pipes: this.objectOptions[4].value,
                obj_pneumatic_pipes: this.objectOptions[5].value,
                obj_blow_off_hoses: this.objectOptions[6].value,

                drying_hot_air: this.dryingOptions[0].value,
                drying_mechanical: this.dryingOptions[1].value,
                drying_evaportation: this.dryingOptions[2].value,

                exam_clean: this.examinationOptions[0].value,
                exam_dry: this.examinationOptions[1].value,
                exam_odeur: this.examinationOptions[2].value,
                exam_ph_measured: this.examinationOptions[3].value,
                exam_ph_measured_result: this.examinationOptions[3].subInput.value,
            }));

            //this.$refs['certificateModal'].hide();
            //this.resetValues();
        },
        resetValues() {
            this.procedureOptions.forEach(option => {
                option.value = false;
                if (option.subInput) {
                    option.subInput.value = null;
                }
            });
            this.objectOptions.forEach(option => {
                option.value = false;
                if (option.subInput) {
                    option.subInput.value = null;
                }
            });
            this.dryingOptions.forEach(option => {
                option.value = false;
            });
            this.examinationOptions.forEach(option => {
                option.value = false;
                if (option.subInput) {
                    option.subInput.value = null;
                }
            });
        },
    },
}
</script>